import { useMediaQuery, useTheme } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import React, { useState, useEffect } from 'react';
import { useObservable } from 'react-use-observable';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';

import { Header } from './Header';
import { List } from './List';
import { useStyles } from './styles';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  selectedQuantity: number;
  selectedAffiliates: IAffiliateOption[];
  handleUncheckAll: () => void;
}

export const Dialog = ({ isOpen, selectedAffiliates, selectedQuantity, onClose, handleUncheckAll }: IProps) => {
  const classes = useStyles();

  const [affiliates] = useObservable(() => selectAffiliateService.getAffiliates(), []);
  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const [affiliateFilter, setAffiliateFilter] = useState('');

  useEffect(() => {
    return () => setAffiliateFilter('');
  }, []);

  const handleClose = () => {
    setAffiliateFilter('');
    onClose();
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAffiliateFilter(e.target.value);
  };

  const filteredAffiliates = affiliateFilter
    ? (affiliates || []).filter((affiliate) => {
        const lowerCaseName = affiliate.name.toLowerCase();
        const lowerCaseEmail = affiliate.email.toLowerCase();
        const lowerCaseFilter = affiliateFilter.toLowerCase();

        return lowerCaseName.includes(lowerCaseFilter) || lowerCaseEmail.includes(lowerCaseFilter);
      })
    : affiliates;

  return (
    <DialogMUI
      open={isOpen}
      scroll='paper'
      aria-labelledby='Selecione seus afiliados'
      aria-describedby='Select múltiplo de afiliados'
      classes={{ paper: classes.dialog }}
      onClose={handleClose}
      fullScreen={isMobile}
    >
      <DialogTitle>
        <Grid container justify='space-between' spacing={2}>
          <Grid item xs={12}>
            {isLoadingAffiliates ? 'Carregando seus afiliados...' : 'Selecione seus afiliados'}
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <DialogContentText className={classes.dialogContentText}>
          <TextField
            className={classes.search}
            placeholder='Procure seu afiliado pelo nome ou e-mail'
            fullWidth
            onChange={handleSearchChange}
            value={affiliateFilter}
            autoFocus
            autoComplete='off'
          />

          <Header handleUncheckAll={handleUncheckAll} selectedQuantity={selectedQuantity} />

          <List selectedAffiliates={selectedAffiliates} affiliates={filteredAffiliates} selectedQuantity={selectedQuantity} />
        </DialogContentText>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button fullWidth onClick={handleClose}>
          Fechar
        </Button>

        <Button variant='contained' color='secondary' onClick={handleClose} fullWidth>
          Confirmar ({selectedQuantity})
        </Button>
      </DialogActions>
    </DialogMUI>
  );
};
